// extracted by mini-css-extract-plugin
export default {"table":"history-table_table__PvtlZ"};